export default "__VITE_ASSET__BRndKdTc__"